$(document).on("click", ".new-bundle-prod-btn", function(){
  let $this = $(this);
  $this.addClass("active");
  let formData = {
  'items': [{
    'id': $this.attr("data-id"),
    'quantity': 1
    }]
  };
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .then(function(res){
    if(res.status){
      console.log("error");
    }
    else{
      $(".cart-icon-wrap .open-drawer").trigger("click");
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  })
  .finally(function(){
    $this.removeClass("active");
  });
})

$(document).on("click", ".new-reviews-tabs-li", function(){
  let title = $(this).attr("data-title");
  $(this).parent().find(".new-reviews-tabs-li").removeClass("active");
  $(this).addClass("active");
  $(this).parents(".new-reviews-tabs-wrapper").find(`.new-reviews-tabs-content`).removeClass("active")
  $(this).parents(".new-reviews-tabs-wrapper").find(`.new-reviews-tabs-content[data-title="${title}"]`).addClass("active");
})

$(document).on("click", ".new-reviews-videos-play", function(){
  if($(this).parents(".new-reviews-videos-item").hasClass("active")){
    $(this).parents(".new-reviews-videos-item").removeClass("active");
    $(this).parent().find(".custom-reviews-videos").trigger("pause");
  }
  else{
    $(this).parents(".new-reviews-videos-item").addClass("active");
    $(this).parent().find(".custom-reviews-videos").trigger("play");
  }
});

$(".custom-reviews-videos").on("timeupdate", function(){
  $(this).parent().find(".new-reviews-videos-seek").css("width", ((($(this).get(0).currentTime)/($(this).get(0).duration))*100)+"%");
})

$(".new-reviews-videos-full-screen").click(function(){
  if($(this).parents(".new-reviews-videos-slide").hasClass("full-screen")){
    $(this).parents(".new-reviews-videos-swiper").removeClass("custom-transform-none");
    $(this).parents(".new-reviews-videos-slide").removeClass("full-screen");
  }
  else{
    $(this).parents(".new-reviews-videos-swiper").addClass("custom-transform-none");
    $(this).parents(".new-reviews-videos-slide").addClass("full-screen");
  }
})

$(document).on("click", ".new-faq-title", function(){
  if($(this).hasClass("active")){
    $(this).toggleClass("active");
    $(this).next().slideToggle(300);
    $(this).parent().addClass("active");
  }
  else{
    $(this).parents(".new-faq-wrapper").find(".new-faq-item").removeClass("active");
    $(this).parents(".new-faq-wrapper").find(".new-faq-title").removeClass("active");
    $(this).parents(".new-faq-wrapper").find(".new-faq-content").slideUp(300);
    $(this).addClass("active");
    $(this).next().slideDown(300);
    $(this).parent().addClass("active");
  }
})

$(document).on("click", ".new-mfaq-title", function(){
  $(this).toggleClass("active");
  $(this).next().slideToggle(300);
})

$(document).on("click", ".new-miwt-btn, .new-mlwt-btn, .new-mcta-btn, .new-faq-link, .new-ing-link, .new-brain-lp-htu-btn, .new-brain-lp-ing-btn-2, .new-brain-lp-iwp-btn, .new-golife-ann-text a, .new-golife-slider-btn, .new-golife-faq-link, .new-golife-htu-btn", function(e){
  e.prevemtDefault();
  if($(this).attr("href").indexOf("#") != -1){
    let id = $(this).attr("href").split("#")[1];
    if($(`#${id}`).length > 0){
      let top = $(`#${id}`).offset().top - 100;
      $("html, body").animate({ scrollTop: top }, 500);
    }
  }
})

$(function(){
  $(".new-main-product-container").each(function(){
  let comb = '';
  $(this).find(".new-main-product-option-value-input:checked").each(function(){
    comb += $(this).val() + ' / ';
  })
  comb = comb.substring(0, comb.length - 2).trim();
  let master = $(this).find(`.new-main-product-master-select li[data-title="${comb}"]`);
  if($(this).find(".new-main-product-main-swiper").length > 0){
    if(master.attr("data-img") != "none"){
      if($(this).find(".custom-sub-opt").length > 0){
        let val = $(this).find(".custom-sub-opt:checked").val();
        if(val == 'sub'){
          if($(this).find(`.new-main-product-main-img[data-img="${master.attr("data-sub-img")}"]`).length > 0){
            let ind = parseInt($(this).find(`.new-main-product-main-img[data-img="${master.attr("data-sub-img")}"]`).attr("data-index"));
            $(this).find(".new-main-product-main-swiper")[0].swiper.slideTo(ind);
          }
          if($(this).find(".new-main-product-option-value-label-hide-sub").length > 0){
            $(this).find(".new-main-product-option-value-label-hide-sub").hide();
          }
        }
        else{
          if($(this).find(`.new-main-product-main-img[data-img="${master.attr("data-img")}"]`).length > 0){
            let ind = parseInt($(this).find(`.new-main-product-main-img[data-img="${master.attr("data-img")}"]`).attr("data-index"));
            $(this).find(".new-main-product-main-swiper")[0].swiper.slideTo(ind);
          }
          if($(this).find(".new-main-product-option-value-label-hide-sub").length > 0){
            $(this).find(".new-main-product-option-value-label-hide-sub").show();
          }
        }
      }
      else{
        if($(this).find(`.new-main-product-main-img[data-img="${master.attr("data-img")}"]`).length > 0){
          let ind = parseInt($(this).find(`.new-main-product-main-img[data-img="${master.attr("data-img")}"]`).attr("data-index"));
          $(this).find(".new-main-product-main-swiper")[0].swiper.slideTo(ind);
        }
      }
    }
  }
  if($(this).find(".new-main-product-info-price").length > 0){
    if($(this).find(".custom-sub-opt").length > 0 && master.length > 0){
       if($(this).find(".custom-sub-opt:checked").val() == "sub"){
        $(this).find(".new-main-product-info-price").html(master.attr("data-discount-1"));
       }
       else{
        $(this).find(".new-main-product-info-price").html(master.attr("data-p"));
       }
    }
    else{
      $(this).find(".new-main-product-info-price").html(master.attr("data-p"));
    }
  }

    if($(this).find(".new-main-product-option-value-input").hasClass("new-main-product-different-price")){
      let targetVal = 0;
      let newArr = [];
      $(this).find(".new-main-product-option-value-input:checked").each(function(){
        if(parseInt($(this).val()) != NaN){
          targetVal = parseInt($(this).val());
        }
      })
      $(this).find(".new-main-product-master-select li").each(function(){
        let dt = $(this).attr("data-title").toLowerCase().trim();
        if(targetVal != 0 && dt.indexOf(targetVal) != -1){
          newArr.push($(this).attr("data-title"));
        }
      })
      if(newArr.length > 0){
        for (let i=0; i < newArr.length; i++){
          let td = newArr[i].toLowerCase().trim();
          if(td.indexOf("subscription") != -1){
            let p = $(this).find(`.new-main-product-master-select li[data-title="${newArr[i]}"]`).attr("data-discount-1");
            $(this).find("#custom-sub-option-price").html(p);
          }
          else if(td.indexOf("one time") != -1){
            let p = $(this).find(`.new-main-product-master-select li[data-title="${newArr[i]}"]`).attr("data-price");
            $(this).find("#custom-one-option-price").html(p);
          }
        }
      } 
    }
  })
})

$(document).on("change", ".custom-sub-opt", function(){
  let $this = $(this).parents(".new-main-product-container");
  let comb = '';
  $this.find(".new-main-product-option-value-input:checked").each(function(){
    comb += $(this).val() + ' / ';
  })
  comb = comb.substring(0, comb.length - 2).trim();
  let master = $this.find(`.new-main-product-master-select li[data-title="${comb}"]`);
  if($this.find(".new-main-product-main-swiper").length > 0){
    if(master.attr("data-img") != "none"){
      if($this.find(".custom-sub-opt").length > 0){
        let val = $this.find(".custom-sub-opt:checked").val();
        if(val == 'sub'){
          if($this.find(`.new-main-product-main-img[data-img="${master.attr("data-sub-img")}"]`).length > 0){
            let ind = parseInt($this.find(`.new-main-product-main-img[data-img="${master.attr("data-sub-img")}"]`).attr("data-index"));
            $this.find(".new-main-product-main-swiper")[0].swiper.slideTo(ind);
          }
        }
        else{
          if($this.find(`.new-main-product-main-img[data-img="${master.attr("data-img")}"]`).length > 0){
            let ind = parseInt($this.find(`.new-main-product-main-img[data-img="${master.attr("data-img")}"]`).attr("data-index"));
            $this.find(".new-main-product-main-swiper")[0].swiper.slideTo(ind);
          }
        }
      }
      else{
        if($this.find(`.new-main-product-main-img[data-img="${master.attr("data-img")}"]`).length > 0){
          let ind = parseInt($this.find(`.new-main-product-main-img[data-img="${master.attr("data-img")}"]`).attr("data-index"));
          $this.find(".new-main-product-main-swiper")[0].swiper.slideTo(ind);
        }
      }
    }
  }
  if($this.find(".new-main-product-option-value-input").hasClass("new-main-product-different-price")){
    let targetVal = 0;
    let newArr = [];
    $this.find(".new-main-product-option-value-input:checked").each(function(){
      if(parseInt($(this).val()) != NaN){
        targetVal = parseInt($(this).val());
      }
    })
    $this.find(".new-main-product-master-select li").each(function(){
      let dt = $(this).attr("data-title").toLowerCase().trim();
      if(targetVal != 0 && dt.indexOf(targetVal) != -1){
        newArr.push($(this).attr("data-title"));
      }
    })
    if(newArr.length > 0){
      for (let i=0; i < newArr.length; i++){
        let td = newArr[i].toLowerCase().trim();
        if(td.indexOf("subscription") != -1){
          let p = $this.find(`.new-main-product-master-select li[data-title="${newArr[i]}"]`).attr("data-discount-1");
          $this.find("#custom-sub-option-price").html(p);
        }
        else if(td.indexOf("one time") != -1){
          let p = $this.find(`.new-main-product-master-select li[data-title="${newArr[i]}"]`).attr("data-price");
          $this.find("#custom-one-option-price").html(p);
        }
      }
    } 
  }
})

$(document).on("change", ".new-main-product-option-value-input", function(){
  let $target = $(this);
  let $this = $(this).parents(".new-main-product-container");
  let comb = '';
  $this.find(".new-main-product-option-value-input:checked").each(function(){
    comb += $(this).val() + ' / ';
  })
  comb = comb.substring(0, comb.length - 2).trim();
  let master = $this.find(`.new-main-product-master-select li[data-title="${comb}"]`);
  if($this.find(".new-main-product-main-swiper").length > 0){
    if(master.attr("data-img") != "none"){
      if($this.find(".custom-sub-opt").length > 0){
        let val = $this.find(".custom-sub-opt:checked").val();
        if(val == 'sub'){
          if($this.find(`.new-main-product-main-img[data-img="${master.attr("data-sub-img")}"]`).length > 0){
            let ind = parseInt($this.find(`.new-main-product-main-img[data-img="${master.attr("data-sub-img")}"]`).attr("data-index"));
            $this.find(".new-main-product-main-swiper")[0].swiper.slideTo(ind);
          }
        }
        else{
          if($this.find(`.new-main-product-main-img[data-img="${master.attr("data-img")}"]`).length > 0){
            let ind = parseInt($this.find(`.new-main-product-main-img[data-img="${master.attr("data-img")}"]`).attr("data-index"));
            $this.find(".new-main-product-main-swiper")[0].swiper.slideTo(ind);
          }
        }
      }
      else{
        if($this.find(`.new-main-product-main-img[data-img="${master.attr("data-img")}"]`).length > 0){
          let ind = parseInt($this.find(`.new-main-product-main-img[data-img="${master.attr("data-img")}"]`).attr("data-index"));
          $this.find(".new-main-product-main-swiper")[0].swiper.slideTo(ind);
        }
      }
    }
  }
  if($this.find(".new-main-product-info-price").length > 0){
    if($this.find(".custom-sub-opt").length > 0 && master.length > 0){
       if($this.find(".custom-sub-opt:checked").val() == "sub"){
        $this.find(".new-main-product-info-price").html(master.attr("data-discount-1"));
       }
       else{
        $this.find(".new-main-product-info-price").html(master.attr("data-p"));
       }
    }
    else{
      $this.find(".new-main-product-info-price").html(master.attr("data-p"));
    }
  }
  if(master.length){
    if(master.attr("data-sold") == "sold"){
      $this.find(".new-main-product-submit").addClass("sold");
      $this.find(".new-main-product-submit").removeClass("preorder");
      $this.find(".new-main-product-submit span").text("Sold Out");
      if($this.find(".new-main-product-preorder-text").length > 0){
        $this.find(".new-main-product-preorder-text").removeClass("active");
      }
    }
    else{
      $this.find(".new-main-product-submit").removeClass("sold");
      if(master.attr("data-preorder") == "true"){
        $this.find(".new-main-product-submit").addClass("preorder");
        $this.find(".new-main-product-submit span").text($this.find(".new-main-product-submit").attr("data-preorder-text"));
        if($this.find(".new-main-product-preorder-text").length > 0){
          $this.find(".new-main-product-preorder-text").addClass("active");
        }
      }
      else{
        $this.find(".new-main-product-submit").removeClass("preorder");
        $this.find(".new-main-product-submit span").text("Add to Cart");
        if($this.find(".new-main-product-preorder-text").length > 0){
          $this.find(".new-main-product-preorder-text").removeClass("active");
        }
      }
    }
    $this.find(".new-main-product-submit").attr("data-id", master.attr("data-id"));
    $this.find(".new-main-product-submit").attr("data-selling-plan", master.attr("data-selling-plan"));
    $this.find("#custom-sub-option-price").html(master.attr("data-discount-1"));
    $this.find("#custom-one-option-price").html(master.attr("data-price"));

    if($target.hasClass("new-main-product-different-price")){
      let targetVal = 0;
      let newArr = [];
      $this.find(".new-main-product-option-value-input:checked").each(function(){
        if(parseInt($(this).val()) != NaN){
          targetVal = parseInt($(this).val());
        }
      })
      $this.find(".new-main-product-master-select li").each(function(){
        let dt = $(this).attr("data-title").toLowerCase().trim();
        if(targetVal != 0 && dt.indexOf(targetVal) != -1){
          newArr.push($(this).attr("data-title"));
        }
      })
      if(newArr.length > 0){
        for (let i=0; i < newArr.length; i++){
          let td = newArr[i].toLowerCase().trim();
          if(td.indexOf("subscription") != -1){
            let p = $this.find(`.new-main-product-master-select li[data-title="${newArr[i]}"]`).attr("data-discount-1");
            $this.find("#custom-sub-option-price").html(p);
          }
          else if(td.indexOf("one time") != -1){
            let p = $this.find(`.new-main-product-master-select li[data-title="${newArr[i]}"]`).attr("data-price");
            $this.find("#custom-one-option-price").html(p);
          }
        }
      } 
    }

    if($this.find(".new-main-product-option-quantity-label").length > 0 && $this.find(".new-main-product-option-value-input--swatch").length > 0){
      let swatch = $this.find(".new-main-product-option-value-input--swatch:checked").val();
      let per_serving = [];
      $this.find(".new-main-product-master-select li").each(function(){
        if($(this).attr("data-title").indexOf(swatch) != -1){
          per_serving.push($(this).attr("data-per"));
        }
      })
      $this.find(".new-main-product-option-quantity-label").each(function(index){
        $(this).find(".new-main-product-option-quantity-per").html(per_serving[index]);
      })
    }
  }
  else{
    $this.find(".new-main-product-submit").addClass("sold");
    $this.find(".new-main-product-submit span").text("Unavailable");
  }
  if($this.find(".custom-sub-opt").length > 0){
    $this.find(".custom-sub-opt[value='one'] + label .custom-sub-name-wrapper dt").removeClass("active");
    $this.find(".custom-sub-opt[value='one'] + label .custom-sub-name-wrapper dd").show();
  }
  if($this.find(".new-main-product-option-value-input--swatch:checked + .new-main-product-option-value-label--swatch").hasClass("new-main-product-option-value-label-hide-sub")){
    let hide_val = $this.find(".new-main-product-option-value-input--swatch:checked").val();
    if(hide_val.indexOf("(") != -1){
      let hide_discount = parseInt(hide_val.split("(")[1]);
      if($this.find(".custom-sub-opt").length > 0){
        $this.find(".custom-sub-opt[value='one'] + label .custom-sub-name-wrapper dt dl").text(` ${hide_discount}% off`);
        $this.find(".custom-sub-opt[value='one'] + label .custom-sub-name-wrapper dd").hide();
        $this.find(".custom-sub-opt[value='one'] + label .custom-sub-name-wrapper dt").addClass("active");
        if($("#custom-one-option-price").length > 0){
          let hp = parseFloat($(master).attr("data-hide-p"));
          let disc = hp  - (hp * hide_discount / 100);
          $this.find("#custom-one-option-price").html(`<span>${Shopify.formatMoney(disc)}</span><strike>${Shopify.formatMoney(hp)}</strike>`);
        }
      }
    }
  }
})

$(document).on("click", ".new-main-product-submit", function(){
  let $parent = $(this).parents(".new-main-product-container");
  let $this = $(this);
  let $variantUpsell = $parent.find(`.new-main-product-master-select li[data-id="${$this.attr("data-id")}"]`).attr("data-upsell");
  let arr = [];
  $this.addClass("active");
    if($(".custom-sub-opt").length > 0){
      let val = $parent.find(".custom-sub-opt:checked").val();
      if(val == 'sub'){
        if($variantUpsell != "none" && $variantUpsell != undefined){
          let variantUpsells = $variantUpsell.split(",");
          for(item of variantUpsells){
            arr.push({
              'id': item.trim(),
              'quantity': 1
            })
          }
        }
        else{
          if($this.parents(".new-main-product-container").find(".new-mp-upsell").length > 0){
            $this.parents(".new-main-product-container").find(".new-mp-upsell").each(function(){
              arr.push({
                'id': $(this).val(),
                'quantity': 1
              })
            })
          }
        }
        if($this.hasClass("preorder")){
          arr.push({
            'id': $this.attr("data-id"),
            'quantity': 1,
            'selling_plan': $this.attr("data-selling-plan"),
            'properties': {'Preorder':'true'}
          })
        }
        else{
          arr.push({
            'id': $this.attr("data-id"),
            'quantity': 1,
            'selling_plan': $this.attr("data-selling-plan")
          })
        }
      }
      else{
        if($this.hasClass("preorder")){
          arr.push({
            'id': $this.attr("data-id"),
            'quantity': 1,
            'properties': {'Preorder':'true'}
          })
        }
        else{
          arr.push({
            'id': $this.attr("data-id"),
            'quantity': 1
          })
        }
      }
    }
    else{
      if($this.hasClass("preorder")){
        arr.push({
          'id': $this.attr("data-id"),
          'quantity': 1,
          'properties': {'Preorder':'true'}
        })
      }
      else{
        arr.push({
          'id': $this.attr("data-id"),
          'quantity': 1
        })
      }
    }
    let formData = {
      'items': arr
    }
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json();
    })
    .then(function(res){
      if(res.status){
        console.log("error");
        if($this.hasClass("preorder")){
          if($parent.find(".new-main-product-preorder-limit-text").length > 0){
            $parent.find(".new-main-product-preorder-limit-text").addClass("active");
            setTimeout(function(){
              $(".new-main-product-preorder-limit-text").removeClass("active");
            }, 3000)
          }
          else{
            $parent.find(".new-main-product-error").text(res.message);
            $parent.find(".new-main-product-error").addClass("active");
            setTimeout(function(){
              $parent.find(".new-main-product-error").removeClass("active");
            }, 3000)
          }
        }
        else{
          $parent.find(".new-main-product-error").text(res.message);
          $parent.find(".new-main-product-error").addClass("active");
          setTimeout(function(){
            $parent.find(".new-main-product-error").removeClass("active");
          }, 3000)
        }
      }
      else{
        if($(this).hasClass("direct--checkout")){
          window.location.href = '/checkout';
        }
        else{
          $(".cart-icon-wrap .open-drawer").trigger("click");
        }
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    })
    .finally(function(){
      $this.removeClass("active");
    });
})

$(document).on("change", ".custom-sub-opt", function(){
  let $this = $(this).parents(".new-main-product-container");
  let buy_wrapper = $this.find(".new-main-product-buy-option");
  if(buy_wrapper != undefined && buy_wrapper.length > 0){
    if($(this).val() == 'sub'){
      buy_wrapper.find(`.new-main-product-option-value-input[data-val="subscription"]`).trigger("click");
    }
    else{
      buy_wrapper.find(`.new-main-product-option-value-input[data-val="one-time"]`).trigger("click");
    }
  }
  if($(this).val() == 'sub'){
    if($this.find(".new-main-product-option-value-label-hide-sub").length > 0){
      $this.find(".new-main-product-option-value-label-hide-sub").hide();
      if($this.find(".new-main-product-option-value-input--swatch:checked + .new-main-product-option-value-label--swatch").hasClass("new-main-product-option-value-label-hide-sub")){
        $this.find(".new-main-product-option-value-input--swatch").eq(0).trigger("click");
      }
    }
  }
  else{
    if($this.find(".new-main-product-option-value-label-hide-sub").length > 0){
      $this.find(".new-main-product-option-value-label-hide-sub").show();
    }
  }

  if($this.find(".new-main-product-option-value-input").hasClass("new-main-product-different-price")){
    let targetVal = 0;
    let newArr = [];
    $this.find(".new-main-product-option-value-input:checked").each(function(){
      if(parseInt($(this).val()) != NaN){
        targetVal = parseInt($(this).val());
      }
    })
    $this.find(".new-main-product-master-select li").each(function(){
      let dt = $(this).attr("data-title").toLowerCase().trim();
      if(targetVal != 0 && dt.indexOf(targetVal) != -1){
        newArr.push($(this).attr("data-title"));
      }
    })
    if(newArr.length > 0){
      for (let i=0; i < newArr.length; i++){
        let td = newArr[i].toLowerCase().trim();
        if(td.indexOf("subscription") != -1){
          let p = $this.find(`.new-main-product-master-select li[data-title="${newArr[i]}"]`).attr("data-discount-1");
          $this.find("#custom-sub-option-price").html(p);
        }
        else if(td.indexOf("one time") != -1){
          let p = $this.find(`.new-main-product-master-select li[data-title="${newArr[i]}"]`).attr("data-price");
          $this.find("#custom-one-option-price").html(p);
        }
      }
    } 
  }
})


  class TypingText extends HTMLElement {
    constructor() {
      super();
      this.attachShadow({ mode: 'open' });
      this.container = document.createElement('span');
      this.shadowRoot.appendChild(this.container);
    }

    connectedCallback() {
      const sentencesAttr = this.getAttribute('sentences');
      if (!sentencesAttr) return;

      this.sentences = sentencesAttr.split(',').map(s => s.trim());
      this.speed = parseInt(this.getAttribute('speed')) || 60;
      this.loop = this.hasAttribute('loop');

      this.startTyping();
    }

    async startTyping() {
      let index = 0;

      do {
        const sentence = this.sentences[index];
        await this.typeSentence(sentence);
        await this.wait(1000);
        await this.deleteSentence(sentence);
        await this.wait(500);
        
        index = (index + 1) % this.sentences.length;
      } while (this.loop || index !== 0);
    }

    async typeSentence(sentence) {
      for (let i = 0; i < sentence.length; i++) {
        this.container.textContent += sentence[i];
        await this.wait(this.speed);
      }
    }

    async deleteSentence(sentence) {
      for (let i = sentence.length; i > 0; i--) {
        this.container.textContent = this.container.textContent.slice(0, -1);
        await this.wait(this.speed);
      }
    }

    wait(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }
  }

  customElements.define('typing-text', TypingText);

  $(document).on("click", ".new-main-product-popup-btn, .new-main-product-popup, .new-main-product-popup-close, .new-brain-lp-ing-btn-1, .new-golife-reason-btn", function(){
    $(".new-main-product-popup").toggleClass("active");
    $("html, body").toggleClass("overflow--hidden");
  })
  $(document).on("click", ".new-main-product-popup-container", function(e){
    e.stopPropagation();
  })

  $(document).on("click", ".new-dynamic-header, .new-bfcm-cart", function(){
    $(".cart-icon-wrap .open-drawer").trigger("click");
  })

  $(document).on("click", ".new-research-story-quote-img, .new-research-doctor-iframe-img", function(){
    $(this).hide();
    $(this).parent().find("iframe").show();
    $(this).parent().find("iframe").attr("src", $(this).attr("data-link"));
  })

  $(document).on("click", ".new-research-faq-title", function(){
  if($(this).hasClass("active")){
    $(this).toggleClass("active");
    $(this).next().slideToggle(300);
  }
  else{
    $(this).parents(".new-research-faq-wrapper").find(".new-research-faq-title").removeClass("active");
    $(this).parents(".new-research-faq-wrapper").find(".new-research-faq-content").slideUp(300);
    $(this).addClass("active");
    $(this).next().slideDown(300);
  }
})


class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.durationHours = parseFloat(this.getAttribute('duration-hours')) || 24;
    this.cookieName = 'countdown_start_time';
  }

  connectedCallback() {
    this.innerHTML = `<span id="timer">--:--:--</span>`;
    this.timerElement = this.querySelector('#timer');
    this.start();
  }

  setCookie(name, value, days) {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
  }

  getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  start() {
    const durationMs = this.durationHours * 60 * 60 * 1000;
    const now = new Date();
    let startTime = this.getCookie(this.cookieName);

    if (!startTime) {
      startTime = now.getTime();
      this.setCookie(this.cookieName, startTime, 7);
    } else {
      startTime = parseInt(startTime, 10);
    }

    const update = () => {
      const current = Date.now();
      let elapsed = current - startTime;

      if (elapsed >= durationMs) {
        // Restart automatically
        startTime = Date.now();
        this.setCookie(this.cookieName, startTime, 7);
        elapsed = 0;
      }

      const remaining = durationMs - elapsed;
      const hours = Math.floor((remaining / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((remaining / (1000 * 60)) % 60);
      const seconds = Math.floor((remaining / 1000) % 60);

      this.timerElement.textContent = 
        `${hours.toString().padStart(2, '0')}:${minutes
          .toString()
          .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

      requestAnimationFrame(update);
    };

    update();
  }
}

if (!customElements.get('countdown-timer')) {
  customElements.define('countdown-timer', CountdownTimer);
}

$(document).on("click", ".new-brain-lp-mp-button, .new-brain-lp-mp-one-button", function(){
  let $this = $(this);
  let arr = [];
  $this.addClass("active");
  if($(this).attr("data-selling-plan") != undefined && $(this).attr("data-selling-plan") != null){
    if($this.parents(".new-brain-lp-mp-wrapper").find(".new-brain-lp-upsell").length > 0){
      $this.parents(".new-brain-lp-mp-wrapper").find(".new-brain-lp-upsell").each(function(){
        arr.push({
          'id': $(this).val(),
          'quantity': 1
        })
      })
    }
    if($this.attr("data-preorder") == "true"){
      arr.push({
        'id': $this.attr("data-id"),
        'quantity': 1,
        'selling_plan': $this.attr("data-selling-plan"),
        'properties': {'Preorder':'true'}
      })
    }
    else{
      arr.push({
        'id': $this.attr("data-id"),
        'quantity': 1,
        'selling_plan': $this.attr("data-selling-plan")
      })
    }
  }
  else{
    if($this.attr("data-preorder") == "true"){
      arr.push({
        'id': $this.attr("data-id"),
        'quantity': 1,
        'properties': {'Preorder':'true'}
      })
    }
    else{
      arr.push({
        'id': $this.attr("data-id"),
        'quantity': 1
      })
    }
  }
  let formData = {
    'items': arr
  }
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .then(function(res){
    if(res.status){
      console.log("error");
    }
    else{
      location.href = '/checkout';
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  })
  .finally(function(){
    $this.removeClass("active");
  });
})

$(document).on("change", ".new-dynamic-product-select", function(){
  let vid = $(this).val();
  let ind = $(this).parent().find(".new-dynamic-product-swiper").find(`.new-dynamic-product-img[data-id="${vid}"]`).attr("data-index");
  let preorder = $(this).find("option:selected").attr("data-preorder");
  $(this).parent().find(".new-dynamic-product-swiper")[0].swiper.slideTo(ind);
  $(this).parent().find(".new-dynamic-product-btn").attr("data-id", vid);
  $(this).parent().find(".new-dynamic-product-btn").attr("data-preorder", preorder);
  if($(this).parent().find(".new-dynamic-product-btn").attr("data-selling-plan") != undefined && $(this).parent().find(".new-dynamic-product-btn").attr("data-selling-plan") != null){
    let sid = $(this).find("option:selected").attr("data-selling-plan");
    $(this).parent().find(".new-dynamic-product-btn").attr("data-selling-plan", sid);
  }
  if($(this).find("option:selected").attr("data-sold") == "available"){
    $(this).parent().find(".new-dynamic-product-btn").removeClass("sold");
    if(preorder == "true"){
      $(this).parent().find(".new-dynamic-product-btn").find("span").text($(this).parent().find(".new-dynamic-product-btn").attr("data-preorder-text"));
    }
    else{
      $(this).parent().find(".new-dynamic-product-btn").find("span").text("Add To Cart");
    }
  }
  else{
    $(this).parent().find(".new-dynamic-product-btn").addClass("sold");
    $(this).parent().find(".new-dynamic-product-btn").find("span").text("Sold Out");
  }
})

$(document).on("click", ".new-dynamic-product-btn", function(){
  let $this = $(this);
  let arr = [];
  $this.addClass("active");
  if($(this).attr("data-selling-plan") != undefined && $(this).attr("data-selling-plan") != null){
    if($this.attr("data-preorder") == "true"){
      arr.push({
        'id': $this.attr("data-id"),
        'quantity': 1,
        'selling_plan': $this.attr("data-selling-plan"),
        'properties': {'Preorder':'true'}
      })
    }
    else{
      arr.push({
        'id': $this.attr("data-id"),
        'quantity': 1,
        'selling_plan': $this.attr("data-selling-plan")
      })
    }
  }
  else{
    if($this.attr("data-preorder") == "true"){
      arr.push({
        'id': $this.attr("data-id"),
        'quantity': 1,
        'properties': {'Preorder':'true'}
      })
    }
    else{
      arr.push({
        'id': $this.attr("data-id"),
        'quantity': 1
      })
    }
  }
  let formData = {
    'items': arr
  }
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .then(function(res){
    if(res.status){
      console.log("error");
    }
    else{
      $(".cart-icon-wrap .open-drawer").trigger("click");
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  })
  .finally(function(){
    $this.removeClass("active");
  });
})

$(document).on("click", ".new-golife-faq-title", function(){
  $(this).toggleClass("active");
  $(this).next().slideToggle(300);
})

$(document).on("click", ".new-desc-product-info-acc-title", function(){
  if($(this).hasClass("active")){
    $(this).toggleClass("active");
    $(this).next().slideToggle(300);
  }
  else{
    $(this).parents(".new-desc-product-info-acc-block").find(".new-desc-product-info-acc-title").removeClass("active");
    $(this).parents(".new-desc-product-info-acc-block").find(".new-desc-product-info-acc-content").slideUp(300);
    $(this).addClass("active");
    $(this).next().slideDown(300);
  }
})

$(document).on("change", ".new-desc-product-option-value-input", function(){
  let comb = '';
  $(this).parents(".new-desc-product-info-wrapper").find(".new-desc-product-option-value-input:checked").each(function(){
    comb += $(this).val() + ' / ';
  })
  comb = comb.substring(0, comb.length - 2).trim();
  let master = $(`.new-desc-product-master-select li[data-title="${comb}"]`);
  if(master.length > 0){
    if($(".new-desc-product-main-swiper").length > 0){
      if(master.attr("data-img") != "none"){
        if($(`.new-desc-product-main-img[data-img="${master.attr("data-img")}"]`).length > 0){
          let ind = parseInt($(`.new-desc-product-main-img[data-img="${master.attr("data-img")}"]`).attr("data-index"));
          $(".new-desc-product-main-swiper")[0].swiper.slideTo(ind);
        }
      }
    }
    if($(".new-desc-product-submit").length > 0){
      $(".new-desc-product-submit").attr("data-id", master.attr("data-id"));
      $(".new-desc-product-submit").attr("data-preorder", master.attr("data-preorder"));
      if(master.attr("data-sold") == "available"){
        $(".new-desc-product-submit").removeClass("sold");
      }
      else{
        $(".new-desc-product-submit").addClass("sold");
      }
    }
    if($(".new-desc-product-selling-plan-input").length > 0){
      let val = $(".new-desc-product-selling-plan-input:checked").val();
      if(val == 'sub'){
        if($(".new-desc-product-info-price-inner-block").length > 0){
          $(".new-desc-product-info-price-inner-block").html(master.attr("data-discount"));
          $(".new-desc-product-info-price em").text(master.attr("data-discount-save"));
          if($(".new-desc-product-submit").length > 0){
            $(".new-desc-product-submit em").text(master.attr("data-atc-discount-price"));
          }
        }
      }
      else{
        if($(".new-desc-product-info-price-inner-block").length > 0){
          $(".new-desc-product-info-price-inner-block").html(master.attr("data-price"));
          $(".new-desc-product-info-price em").text(master.attr("data-price-save"));
          if($(".new-desc-product-submit").length > 0){
            $(".new-desc-product-submit em").text(master.attr("data-atc-price"));
          }
        }
      }
    }
  }
});

$(document).on("change", ".new-desc-product-selling-plan-input", function(){
  let comb = '';
  $(this).parents(".new-desc-product-info-wrapper").find(".new-desc-product-option-value-input:checked").each(function(){
    comb += $(this).val() + ' / ';
  })
  comb = comb.substring(0, comb.length - 2).trim();
  let master = $(`.new-desc-product-master-select li[data-title="${comb}"]`);
  console.log(master, $(this).val());
  if($(this).val() == 'sub'){
    let val = $(".new-desc-product-selling-plan-select").val();
    $(".new-desc-product-selling-plan-select-wrapper").show();
    if($(".new-desc-product-submit").length > 0){
      $(".new-desc-product-submit").attr("data-selling-plan", val);
      if(master.length > 0){
        if($(".new-desc-product-info-price-inner-block").length > 0){
          $(".new-desc-product-info-price-inner-block").html(master.attr("data-discount"));
          $(".new-desc-product-info-price em").text(master.attr("data-discount-save"));
        }
        $(".new-desc-product-submit em").text(master.attr("data-atc-discount-price"));
      }
    }
  }
  else{
    $(".new-desc-product-selling-plan-select-wrapper").hide();
    if($(".new-desc-product-submit").length > 0){
      $(".new-desc-product-submit").attr("data-selling-plan", "none");
      if(master.length > 0){
        if($(".new-desc-product-info-price-inner-block").length > 0){
          $(".new-desc-product-info-price-inner-block").html(master.attr("data-price"));
          $(".new-desc-product-info-price em").text(master.attr("data-price-save"));
        }
        $(".new-desc-product-submit em").text(master.attr("data-atc-price"));
      }
    }
  }
})

$(document).on("change", ".new-desc-product-selling-plan-select", function(){
  if($(".new-desc-product-submit").length > 0){
    $(".new-desc-product-submit").attr("data-selling-plan", $(this).val());
  }
})

$(document).on("click", ".new-desc-product-submit", function(){
  let $this = $(this);
  let arr = [];
  $this.addClass("active");
  if($(this).attr("data-selling-plan") != "none"){
    if($this.parents(".new-desc-product-wrapper").find(".new-desc-upsell").length > 0){
      $this.parents(".new-desc-product-wrapper").find(".new-desc-upsell").each(function(){
        arr.push({
          'id': $(this).val(),
          'quantity': 1
        })
      })
    }
    if($this.attr("data-preorder") == "true"){
      arr.push({
        'id': $this.attr("data-id"),
        'quantity': 1,
        'selling_plan': $this.attr("data-selling-plan"),
        'properties': {'Preorder':'true'}
      })
    }
    else{
      arr.push({
        'id': $this.attr("data-id"),
        'quantity': 1,
        'selling_plan': $this.attr("data-selling-plan")
      })
    }
  }
  else{
    if($this.attr("data-preorder") == "true"){
      arr.push({
        'id': $this.attr("data-id"),
        'quantity': 1,
        'properties': {'Preorder':'true'}
      })
    }
    else{
      arr.push({
        'id': $this.attr("data-id"),
        'quantity': 1
      })
    }
  }
  let formData = {
    'items': arr
  }
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .then(function(res){
    if(res.status){
      console.log("error");
    }
    else{
      $(".cart-icon-wrap .open-drawer").trigger("click");
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  })
  .finally(function(){
    $this.removeClass("active");
  });
})

$(document).on("click", ".new-vault-coll-item-submit, .new-fc-atc", function(){
  let $this = $(this);
  let arr = [];
  $this.addClass("active");
  if($(this).attr("data-selling-plan") != "none"){
    if($this.attr("data-preorder") == "true"){
      arr.push({
        'id': $this.attr("data-id"),
        'quantity': 1,
        'selling_plan': $this.attr("data-selling-plan"),
        'properties': {'Preorder':'true'}
      })
    }
    else{
      arr.push({
        'id': $this.attr("data-id"),
        'quantity': 1,
        'selling_plan': $this.attr("data-selling-plan")
      })
    }
  }
  else{
    if($this.attr("data-preorder") == "true"){
      arr.push({
        'id': $this.attr("data-id"),
        'quantity': 1,
        'properties': {'Preorder':'true'}
      })
    }
    else{
      arr.push({
        'id': $this.attr("data-id"),
        'quantity': 1
      })
    }
  }
  let formData = {
    'items': arr
  }
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .then(function(res){
    if(res.status){
      console.log("error");
    }
    else{
      $(".cart-icon-wrap .open-drawer").trigger("click");
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  })
  .finally(function(){
    $this.removeClass("active");
  });
})

$(document).on("change", ".new-fc-select", function(){
  let id = $(this).val();
  let sp = $(this).find("option:selected").attr("data-selling-plan");
  let po = $(this).find("option:selected").attr("data-preorder");
  let sold = $(this).find("option:selected").attr("data-sold");
  let img = $(this).find("option:selected").attr("data-img");
  let price = $(this).find("option:selected").attr("data-price");
  let btn = $(this).parent().find(".new-fc-atc");
  btn.attr("data-selling-plan", sp);
  btn.attr("data-preorder", po);
  btn.attr("data-id", id);
  $(this).closest(".item-single").find("img").attr("src", img);
  $(this).closest(".item-single").find(".new-fp-price").html(price);
  if(sold == "true"){
    btn.addClass("sold");
  }
  else{
    btn.removeClass("sold");
  }
})



  $(function () {
  if (window.BFCountdownDefined) return;
  window.BFCountdownDefined = true;

  class BFCountdown extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.wrapper = document.getElementById(`bf-wrapper-${this.sectionId}`);

      // Example: "Nov/29/2025 06:00 PM"
      this.endDateString = this.dataset.endDate;

      this.daysEl = this.querySelector('[data-unit="days"]');
      this.hoursEl = this.querySelector('[data-unit="hours"]');
      this.minutesEl = this.querySelector('[data-unit="minutes"]');
      this.secondsEl = this.querySelector('[data-unit="seconds"]');

      this.endTimeUTC = this.parseESTtoUTC(this.endDateString);

      this.start();
    }

    // Convert EST string into UTC date
    parseESTtoUTC(dateString) {
      // dateString example: "Nov/27/2025 02:55 PM"
      
      const parts = dateString.match(/(\w+)\/(\d+)\/(\d+)\s+(\d+):(\d+)\s+(AM|PM)/i);
      if (!parts) return null;

      const months = {
        Jan:0, Feb:1, Mar:2, Apr:3, May:4, Jun:5,
        Jul:6, Aug:7, Sep:8, Oct:9, Nov:10, Dec:11
      };

      const month = months[parts[1]];
      const day   = parseInt(parts[2]);
      const year  = parseInt(parts[3]);
      let hour    = parseInt(parts[4]);
      const minute= parseInt(parts[5]);
      const ampm  = parts[6].toUpperCase();

      if (ampm === "PM" && hour !== 12) hour += 12;
      if (ampm === "AM" && hour === 12) hour = 0;

      // Build EST time manually (UTC -5)
      const est = new Date(Date.UTC(year, month, day, hour + 5, minute, 0));

      return est; // this is now correct UTC timestamp
    }

    start() {
      this.update();
      this.timer = setInterval(() => this.update(), 1000);
    }

    update() {
      const nowUTC = new Date(); // Always compare in UTC

      if (nowUTC >= this.endTimeUTC) {
        this.hideSection();
        return;
      }

      const diff = this.endTimeUTC - nowUTC;
      const totalSeconds = Math.floor(diff / 1000);

      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      this.render(days, hours, minutes, seconds);
    }

    hideSection() {
      clearInterval(this.timer);
      if (this.wrapper) this.wrapper.style.display = "none";
    }

    render(d, h, m, s) {
      this.daysEl.textContent = this.pad(d);
      this.hoursEl.textContent = this.pad(h);
      this.minutesEl.textContent = this.pad(m);
      this.secondsEl.textContent = this.pad(s);
    }

    pad(n) {
      return n < 10 ? "0" + n : n;
    }
  }

  customElements.define("bf-countdown", BFCountdown);
  });


class TimedVisibility extends HTMLElement {
  connectedCallback() {
    const startStr = this.dataset.start;
    const endStr = this.dataset.end;

    if (!startStr || !endStr) {
      console.warn("TimedVisibility: Missing start or end date.");
      return;
    }

    const startDateUTC = this.parseESTtoUTC(startStr);
    const endDateUTC   = this.parseESTtoUTC(endStr);

    if (!startDateUTC || !endDateUTC) {
      console.error("TimedVisibility: Invalid date format.");
      return;
    }

    const nowUTC = new Date();

    // Compare in UTC (clean & accurate)
    if (nowUTC >= startDateUTC && nowUTC <= endDateUTC) {
      this.style.display = "flex";
    } else {
      this.style.display = "none";
    }
  }

  // Parse "Nov/27/2025 06:00 PM" into a proper UTC date
  parseESTtoUTC(dateString) {
    const parts = dateString.match(/(\w+)\/(\d+)\/(\d+)\s+(\d+):(\d+)\s+(AM|PM)/i);
    if (!parts) return null;

    const months = {
      Jan:0, Feb:1, Mar:2, Apr:3, May:4, Jun:5,
      Jul:6, Aug:7, Sep:8, Oct:9, Nov:10, Dec:11
    };

    const month  = months[parts[1]];
    const day    = parseInt(parts[2]);
    const year   = parseInt(parts[3]);
    let hour     = parseInt(parts[4]);
    const minute = parseInt(parts[5]);
    const ampm   = parts[6].toUpperCase();

    // Convert AM/PM to 24h format
    if (ampm === "PM" && hour !== 12) hour += 12;
    if (ampm === "AM" && hour === 12) hour = 0;

    // EST is UTC-5 → to convert EST → UTC, we ADD 5 hours
    const utcDate = new Date(Date.UTC(year, month, day, hour + 5, minute, 0));

    return utcDate;
  }
}

customElements.define("timed-visibility", TimedVisibility);